import { useMutation } from '@tanstack/react-query';

import { FlightEventClient, FlightEventReport } from '../../clients';
import queryKeys from '../../queryKeys';
import { apiBaseUrl } from '../../../config';

const flightEventClient = new FlightEventClient(apiBaseUrl);

function useSaveNewFlightEvent() {
  return useMutation({
    mutationKey: [queryKeys.FlightEvent.SaveNew],
    mutationFn: (report: FlightEventReport) => flightEventClient.saveNew(report),
  });
}

export default useSaveNewFlightEvent;
